import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom'
import { Container, Title, CloseButton, Icon, Backdrop } from './modal.styled';

const ESC_KEY_CODE = 27;
const EVENT_TYPE = 'keydown';

export interface ModalProps {
    title?: string;
    toggle: () => void;
    isShown: boolean;
    width?: number;
    top?: string;
    target: HTMLElement | any;
    handleClose?: () => void;
    background?: string;
    zIndex?: number;
    showCloseButton?: boolean;
    closeOnEsc?: boolean;
}

const Modal: React.FC<ModalProps> = ({ title, toggle, children, isShown, target, handleClose, background , zIndex, showCloseButton=true, closeOnEsc=false, ...props }) => {
    const onHandleClose = useCallback(() => {
        if(handleClose)
            return handleClose();
        else
            return toggle();
    }, [toggle, handleClose]);

    const handleKeyPressed = useCallback((event) => {
        if (isShown && showCloseButton && event.keyCode === ESC_KEY_CODE) {
            onHandleClose();
        }
    }, [showCloseButton, isShown, onHandleClose]);

    useEffect(() => {
        if(closeOnEsc){
            document.addEventListener(EVENT_TYPE, handleKeyPressed, false);
            return () => {
                document.removeEventListener(EVENT_TYPE, handleKeyPressed, false);
            };
        }
    }, [closeOnEsc, handleKeyPressed]);

    useEffect(() => {
        document.body.style.overflow = isShown ? 'hidden' : 'unset';
    }, [isShown]);

    const content =
        <>
            <Backdrop onClick={() => onHandleClose()} isShown={isShown} style={{zIndex: zIndex}}/>
            <Container {...props} background={background}>
                {showCloseButton && <CloseButton onClick={() => onHandleClose()}>
                    <Icon src="/assets/img/inco-close.svg" />
                </CloseButton>}
                {Title && <Title>{title}</Title>}
                {children}
            </Container>
        </>

    return isShown ? createPortal(content, target) : null;
}

export default Modal;